import React from 'react';
import { Company } from '../../models';
import { Button, TableCell, TableRow } from '@mui/material';

interface CompanyTableRowProps {
  company: Company
  dark: boolean,
  restore: boolean,
  onCompanyEdit?: (company: Company) => void
  onCompanyStatusChange?: (company: Company, status: Company["status"]) => void
}

export const CompanyTableRow: React.FC<CompanyTableRowProps> = ({
  company,
  dark,
  restore,
  onCompanyEdit,
  onCompanyStatusChange,
}) => {
  const created = company.createdAt ? new Date(company.createdAt) : null;

  return (
    <TableRow className={dark ? 'dark_row' : 'light_row'}>
      <TableCell className="table_cell">{company.id}</TableCell>
      <TableCell className="table_cell">{company.name}</TableCell>
      <TableCell className="table_cell">
        {created && `${created.getDate()}/${created.getMonth() + 1}/${created.getFullYear()}`}
      </TableCell>
      <TableCell>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          {!restore && <Button onClick={() => onCompanyEdit?.(company)} size="small" variant="contained" color="secondary">
            Edit
          </Button>}
          {restore
            ? <Button onClick={() => onCompanyStatusChange?.(company, "active")} size="small" variant="contained" color="secondary">Restore</Button>
            : <Button onClick={() => onCompanyStatusChange?.(company, "deleted")} size="small" variant="contained" color="secondary">Delete</Button>
          }
        </div>
      </TableCell>
    </TableRow>
  );
};
